import { Box, Center, Stack, Typography } from '@ethings/ui-toolkit';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTitle } from '../../hooks';

export const NotFound: FC = () => {
  const { t } = useTranslation(['common']);
  useTitle(t('common:page.errors.not-found.title'));

  return (
    <Box width='100%' height='100%'>
      <Center>
        <Stack spacing={1} maxWidth='400px'>
          <Box>
            <Typography variant="h1" color="primary">404</Typography>
          </Box>
          <Box>
            <Typography>
              {t('common:page.errors.not-found.hint')}
            </Typography>
          </Box>
        </Stack>
      </Center>
    </Box>
  );
};
